import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { FieldType } from '@ngx-formly/material';
import { DecimalFormatDirective } from '../../directives/decimal-format.directive';
import { NumbersOnlyDirective } from '../../directives/numbers-only.directive';

@Component({
    selector: 'decimal-input',
    template: `<input
		matInput
		[formControl]="formControl"
		[maxlength]="to.maxLength"
		[readonly]="to.readonly"
		[formlyAttributes]="field"
		decimalFormat
		numbersOnly
		(change)="to.change && to.change(this.field)"
	/>`,
    standalone: true,
    imports: [
        MatInputModule,
        FormsModule,
        DecimalFormatDirective,
        NumbersOnlyDirective,
        ReactiveFormsModule,
        FormlyModule,
    ],
})
export class FormlyDecimalInputComponent extends FieldType<FormlyFieldConfig> {}
